module.exports = __webpack_public_path__ + "static/img/ten.89c44ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/expert/ten.png
// module id = oLQ5
// module chunks = 0